import React from "react";
import { CommonProps } from "fds/src/helpers/props";

export interface IProps extends CommonProps {
  stroke?: string;
  width?: string | number | undefined;
  height?: string | number | undefined;
}
const SuccessIcon: React.FC<IProps> = ({ classes, stroke, width, height }) => {
  return (
    <svg
      width={width || "60"}
      height={height || "60"}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M29.9987 54.9981C43.8058 54.9981 54.9987 43.8052 54.9987 29.998C54.9987 16.1909 43.8058 4.99805 29.9987 4.99805C16.1916 4.99805 4.99872 16.1909 4.99872 29.998C4.99872 43.8052 16.1916 54.9981 29.9987 54.9981Z"
        fill={stroke || "#5E92F5"}
      />
      <path
        d="M18.2988 29.9668L26.0989 37.7714L41.655 22.2012"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SuccessIcon;
